import GangstaverseInfo from "@components/home/GangstaverseInfo.component";
import GangstaverseLand from "@components/home/GangstaverseLand.component";
import GangstaverseStat from "@components/home/GangstaverseStat.component";
import TopSold from "@components/home/TopSold.component";
import Gangstaverse from "@components/home/gangstaverseBlocks/Gangstaverse.block";
import Timeline from "@components/timeline/Timeline.component";
import Carousel from "@components/home/Carousel.component";
import ProductSection from "@components/home/ProductSection.component";
import EmeraldCityMapLeaflet from "@components/home/EmeraldCityMapLeaflet.component";

const Home = () => {
  return (
    <div>
      <GangstaverseInfo />
      <ProductSection />
      {/* <Gangstaverse /> */}
      <GangstaverseLand />
      <EmeraldCityMapLeaflet />
      <GangstaverseStat />
      <TopSold />
      {/* <Carousel /> */}

      <Timeline />
    </div>
  );
};

export default Home;
